<template>
  <div class="position-relative px-3" :class="classes">
    <div class="avatar-and-title d-flex">
      <div class="mr-3">
        <system-avatar v-if="isSystemEvent" />
        <researcher-avatar v-else :researcher="researcher" medium />
      </div>
      <div class="d-flex flex-column justify-center title-and-date">
        <div class="d-flex align-center text-body-2">
          <v-icon
            v-if="icon"
            size="16"
            class="mr-1 material-icons-outlined"
            :color="iconColor"
          >
            {{ icon }}
          </v-icon>
          <slot></slot>
        </div>
        <div class="caption font-weight-light grey--text">
          {{ dateText }}
        </div>
      </div>
    </div>
    <div
      class="pl-13 pb-4"
      :class="!bottomNode && 'has-vertical-line'"
    >
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import SystemAvatar from '@/components/Common/SystemAvatar';
import format from 'date-fns/format';
import { Researcher } from '@/models';

export default {
  name: 'BaseEventLogItem',
  components: {
    ResearcherAvatar,
    SystemAvatar,
  },
  props: {
    researcher: {
      type: Researcher,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: 'grey darken-2',
    },
    date: {
      type: Date,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    isSystemEvent() {
      return !this.researcher;
    },
    dateText() {
      return format(this.date, 'd MMMM, yyyy h:mm a');
    },
    classes() {
      return this.color && `offset-bg-${this.color}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.avatar-and-title {
  position: relative;
  height: 40px;
}
.title-and-date {
  max-width: calc(100% - 50px);
  white-space: nowrap;
}
.offset-bg-success::before {
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: calc(100% + 4px);
  background-color: map-get($green, 'lighten-4');
  content: '';
}
.offset-bg-error::before {
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: calc(100% + 4px);
  background-color: map-get($red, 'lighten-5');
  content: '';
}
.has-vertical-line::before {
  position: absolute;
  top: 40px;
  left: 32px;
  width: 1px;
  height: calc(100% - 40px);
  background-color: map-get($grey, 'lighten-2');
  content: '';
}
</style>
